import { useActionState, useContext, useEffect, useState } from "react";

import axios from "axios";
import { motion } from 'framer-motion';

import AppContext from "../contexts/AppContext";
import CookieContext from "../contexts/CookieContext";

const ActionState = () => {
  const { cookies } = useContext(CookieContext);
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'checklist/';

  const [error, setError] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [checklists, setChecklists] = useState([]);

  const fetchChecklists = async (param) => {

    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setChecklists(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
    } catch (err) {
      console.log(err);
      setError('通信エラー');
    } finally {
    }
  }

  const [state, formAction, isPending] = useActionState(async (prevState, formData) => {
    // バリデーション
    if (formData.get("name") === null || formData.get("name") === '') {
      setErrorMessage('メッセージを入力してください')
    } else {
      setErrorMessage('')
    }

    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(`${apiHost}${basePath}`, 
          {
            name: formData.get('name'),
          },
          {headers},
        )

        if (response.status === 201) {
          // 更新した名前を返す
          return response.data.name
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
      setError('通信エラー');
    } finally {
    }
  }, "");

  async function handleClick(checklistId) {
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.put(`${apiHost}${basePath}check/${checklistId}/`, 
          {
            // checklist.idをurlで指定して、is_checkedを反転させるだけなので、下記のような更新するパラメータは不要
            // is_checked: true
            // name: formData.get('checklistName'),
            // name: inputRef.current.value,
          },
          {headers},
        )

        if (response.status === 200) {
          fetchChecklists()
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
      setError('通信エラー');
    } finally {
    }
  }

  // load時
  useEffect(() => {
    fetchChecklists();
  }, [state, errorMessage]);

  return (
    <>
      <form action={formAction}>
        {/* <input style={{ margin: "5px", fontSize: 30, }} type="text" name="checklistName" placeholder="メッセージを入力" ref={inputRef} /> */}
        <input style={{ margin: "5px", fontSize: 30, }} type="text" name="name" placeholder="メッセージを入力" />

        <AppButton type="submit" style={{ margin: "5px", fontSize: 30}} disabled={isPending}>送信</AppButton>
        {/* 送信中の表示 */}
        {isPending && <>送信中...</>}
        {/* 更新完了時の表示 */}
        {!isPending && state}
      </form>
      <motion.div
          initial={{ opacity: 0, color: '#ff0000' }}
          animate={{ opacity: 1, color: '#ff0000' }}
          transition={{ delay: 0, duration: 1, repeat: Infinity }}
        >
        {errorMessage}
      </motion.div>

      <div className="contents">
        <ul className="contents_ul">
          {checklists.map(checklist => (
            <li className="contents_li" key={checklist.id}>
              {checklist.checked_datetime}
              <button onClick={() => handleClick(checklist.id)}>
                {checklist.is_checked ? '完了' : '未完了'}
              </button>
              [{checklist.id}]
              {checklist.name}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
export default ActionState